<template>
  <b-modal v-model="vModel" size="xl" hide-footer :title="reportingRoadDisturbance ? 'Signalement de désordre de voirie après réception' : 'Réception'">
    <div v-if="reportingRoadDisturbance == false">
      <div ref="recepPhotos" v-if="receptionSelected.option == 'Photos'">
        <div
          v-for="document in request.documents"
          v-if="document.typeDocument.nature === 'réception'"
        >
          <div class="line-document">
            <img
              style="display: none"
              :src="document.url"
              :class="'photos_recep' + document.id"
              v-viewer.rebuild="{ scalable: false, movable: true }"
              v-if="imageMimeType.includes(document.mimeType)"
            />
            {{ document.typeDocument.name }}
            <span
              class="action"
              :id="'open-document-' + document.id"
              @click="open(document)"
              >
              <font-awesome-icon icon="eye"/>
            </span>
          </div>
        </div>

        <b-row>
          <b-col lg="3" md="12" sm="12" cols="12">
            <label>Partie du domaine public :</label>
          </b-col>
          <b-col lg="8" md="12" sm="12" cols="12">
            <b>{{
              reception.partieDomainePublic
                ? reception.partieDomainePublic.join(", ")
                : ""
            }}</b>
          </b-col>
        </b-row>
      </div>

      <b-form-group class="reception-group">
        <div class="my-4 w-25">
          <label for="date-visite">Date de visite:</label>
          <b-form-datepicker id="date-visite" v-model="receptionSelected.dateVisite"></b-form-datepicker>
        </div>
        <b-form-radio-group v-model="receptionSelected.avis" name="radio-avis-reception">
          <b-row>
            <b-col lg="1" md="10" sm="12" cols="12"><label>Avis :</label></b-col>
            <b-col lg="2" md="10" sm="12" cols="12">
              <b-form-radio value="accepté">Accepté</b-form-radio>
            </b-col>
            <b-col lg="1" md="10" sm="12" cols="12">
              <b-form-radio value="refusé">Refusé</b-form-radio>
            </b-col>
          </b-row>
          <div v-if="receptionSelected.avis === 'refusé'">
            <b-row>
              <b-col lg="2" md="3" sm="12" cols="12">
                <label>Motif de refus :</label>
              </b-col>
              <b-col lg="10" md="10" sm="12" cols="12">
                <b-form-checkbox-group
                  v-model="receptionSelected.motifRefus"
                  :options="optionsMotifsRefusReception"
                ></b-form-checkbox-group>
              </b-col>
              <b-col
                lg="4"
                md="4"
                sm="12"
                cols="12"
                v-if="
                  receptionSelected.motifRefus &&
                    receptionSelected.motifRefus.includes('autre')
                "
              >
                <b-form-input
                  type="text"
                  v-model="receptionSelected.motifRefusTxt"
                  placeholder="Précisez le motif de refus"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
            <b-col cols="6" v-for="(photo, index) in photoReceptionRefus" :key="index" class="mb-2">
              Photo {{ index + 1 }} :
              <b-form-file
                browse-text="Ouvrir"
                v-model="photo.file"
                placeholder="Choisissez un fichier"
                accept="image/jpeg, application/pdf, image/bmp, image/png"
              ></b-form-file>
            </b-col>
          </b-row>
          </div>
        </b-form-radio-group>
      </b-form-group>
    </div>

    <div v-if="reportingRoadDisturbance == true">
      <b-row class="mb-4">
        <b-col cols="6">
          Instructeur:
          <b-form-select v-model="instructeurSelected" :options="instructeurs"></b-form-select>
          <b-form-textarea
            id="comment"
            v-model="comment"
            placeholder="Commentaire"
            rows="3"
            max-rows="3"
          ></b-form-textarea>
        </b-col>
        <b-col cols="6">
          Photo:
          <b-form-file
          browse-text="Ouvrir"
          v-model="photo.file"
          placeholder="Choisissez un fichier"
          accept="image/jpeg,
          application/pdf,
          image/bmp,
          image/png"
          ></b-form-file>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <template v-if="reportingRoadDisturbance">
        <b-col lg="2" md="2" sm="12" cols="12" v-if="!showBtnGenProcesVerbalDesordreVoirie">
          <b-button
            @click="
              vModel = false;
              addRoadDisturbance(receptionSelected)
            "
            variant="primary"
            block
            class="btn-auto pr-4 pl-4 mb-2"
          >
            Valider
          </b-button>
        </b-col>
        <b-col lg="2" md="2" sm="12" cols="12" v-if="showBtnGenProcesVerbalDesordreVoirie">
          <b-button
            @click="doCourrier(receptionSelected, 'dv')"
            variant="info"
            block
            class="btn-auto pr-4 pl-4"
          >
            <span>Générer le procès verbal</span>
          </b-button>
        </b-col>
      </template>
      <template v-else>
        <b-row>
          <b-col lg="12" md="12" sm="12" cols="12" v-if="showBtnEditProcesVerbal">
            <b-button
              @click="doCourrier(receptionSelected, 'pv')"
              variant="info"
              block
              :disabled="showBtnGenProcesVerbal"
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Générer le PV</span>
            </b-button>
          </b-col>
          <b-col lg="6" md="6" sm="12" cols="12" v-if="!showBtnEditProcesVerbal">
            <b-button
              @click="editCourrier('pv')"
              :disabled="showBtnEditProcesVerbal"
              variant="info"
              block
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Editer le PV</span>
            </b-button>
          </b-col>
          <b-col lg="6" md="6" sm="12" cols="12" v-if="!showBtnEditProcesVerbal">
            <b-button
              @click="removeCourrier('pv')"
              :disabled="showBtnEditProcesVerbal"
              variant="danger"
              block
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Supprimer le PV</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="receptionSelected.avis == 'refusé'">
          <b-col lg="12" md="3" sm="12" cols="12" v-if="showBtnEditMiseEnDemeure">
            <b-button
              @click="doCourrier(receptionSelected, 'md')"
              variant="info"
              block
              :disabled="showBtnGenMiseEnDemeure"
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Générer la mise en demeure</span>
            </b-button>
          </b-col>
          <b-col lg="6" md="6" sm="12" cols="12" v-if="!showBtnEditMiseEnDemeure">
            <b-button
              @click="editCourrier('md')"
              :disabled="showBtnEditMiseEnDemeure"
              variant="info"
              block
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Editer la mise en demeure</span>
            </b-button>
          </b-col>
          <b-col lg="6" md="6" sm="12" cols="12" v-if="!showBtnEditMiseEnDemeure">
            <b-button
              @click="removeCourrier('md')"
              :disabled="showBtnEditMiseEnDemeure"
              variant="danger"
              block
              class="btn-auto pr-4 pl-4 mb-2"
            >
              <span>Supprimer la mise en demeure</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="isValidating && validationStep">
          <b-col cols="12" class="text-center text-muted mb-2">
            <b-spinner small class="mr-2" />
            {{ validationStep }}
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="4" sm="12" cols="12">
            <b-button
              @click="newReception(receptionSelected, false, false)"
              variant="white"
              block
              class="btn-auto pr-4 pl-4 mb-2"
              :disabled="isValidating"
            >
              Fermer et sauvegarder le brouillon
            </b-button>
          </b-col>
          <b-col lg="4" md="4" sm="12" cols="12">
            <b-button
              @click="newReception(receptionSelected, false, true)"
              variant="primary"
              block
              class="btn-auto pr-4 pl-4 mb-2"
              :disabled="showBtnValider || isValidating"
            >
              {{ isValidating ? "Validation en cours…" : "Valider" }}
            </b-button>
          </b-col>
          <b-col lg="4" md="4" sm="12" cols="12">
            <b-button
              @click="vModel = false"
              variant="secondary"
              block
              class="btn-auto pr-4 pl-4"
              :disabled="isValidating"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-row>
    <div v-if="reportingRoadDisturbance && pvDesordreVoirie.length > 0" class="mt-4">
      <hr>
      <h5>
        PV de désordre de voirie émis:
      </h5>
      <b-row class="pv-dv-header">
        <b-col cols="4">
          Nom
        </b-col>
        <b-col cols="4">
          Date d'émission
        </b-col>
        <b-col cols="4">
          Actions
        </b-col>
      </b-row>
      <b-row v-for="pv in pvDesordreVoirie">
        <b-col cols="4">
          {{ pv.name }}
        </b-col>
        <b-col cols="4">
          {{ pv.createdAt }}
        </b-col>
        <b-col cols="4">
          <b-button variant="info" @click="editCourrierDv(pv.id)">
            Editer le PV
          </b-button>
          <b-button variant="danger" class="ml-1" @click="removeCourrierDv(pv.id)">
            Supprimer le PV
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import VuePdfPreview from "vue-pdf";
import VueDocPreview from "vue-doc-preview";
import moment from "moment";
Vue.use(Viewer);
export default {
  components: {
    "vue-doc-preview": VueDocPreview,
    "vue-pdf-preview": VuePdfPreview,
  },
  props: ["value", "reportingRoadDisturbance"],
  data() {
    return {
      optionsMotifsRefusReception: [
        {
          text: "Joints",
          value: "joints",
        },
        {
          text: "Redans",
          value: "redans",
        },
        {
          text: "Prescriptions non respectées",
          value: "prescriptions non respectées",
        },
        {
          text: "Autre",
          value: "autre",
        },
      ],
      viewerPdf: false,
      viewerDoc: false,
      pdfToView: "",
      docToView: "",
      ImgDoc: require("../../assets/document.png"),
      ImgPdf: require("../../assets/pdf.png"),
      imageMimeType: ["image/png", "image/gif", "image/jpeg"],
      pdfMimeType: ["application/pdf"],
      DocMimeType: [
        "application/octet-stream",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "pplication/vnd.oasis.opendocument.text",
        "application/vnd.ms-powerpoint",
        "text/csv",
        "application/vnd.ms-office",
        "text/plain",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ],
      roadDisturbance: false,
      showBtnGenProcesVerbalDesordreVoirie: true,
      instructeurSelected: null,
      instructeurs: [
        {
          value: "Mégane Allegre",
          text: "Mégane Allegre",
        },
        {
          value: "Pierre Moens",
          text: "Pierre Moens",
        },
        {
          value: "Remi Morel",
          text: "Remi Morel",
        },
        {
          value: "Claire Sengel",
          text: "Claire Sengel",
        },
      ],
      comment: '',
      photoReceptionRefus: [
        { file: null, typeDocument: {} },
        { file: null, typeDocument: {} },
        { file: null, typeDocument: {} },
        { file: null, typeDocument: {} },
        { file: null, typeDocument: {} }
      ],
      photo: {
        file: null,
        typeDocument: {},
      },
      imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
      pvDesordreVoirie: [],
      isValidating: false,
      validationStep: "",
    };
  },
  methods: {
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        const viewer = this.$refs.recepPhotos.querySelector(
          ".photos_recep" + doc.id
        ).$viewer;
        viewer.show();
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
      }
    },
    buildDossierPayload(receptionData, options = {}) {
      const payload = {
        ...this.request,
        stateId: receptionData.stateId,
        lat: this.request.lat,
        lon: this.request.lon,
      };
      if (options.sendToSign) {
        payload.sendToSign = true;
      }
      return payload;
    },
    /**
     * Payload de brouillon : ne doit jamais porter de stateId de transition,
     * pour ne pas réécrire le statut du dossier via PUT /reception.
     */
    buildReceptionDraftPayload(data) {
      const draft = {
        id: this.request.id,
        requestId: this.request.id,
        roadDisturbance: data.roadDisturbance === true,
        dateVisite: data.dateVisite != null ? data.dateVisite : null,
        avis: data.avis != null ? data.avis : null,
        option: data.option != null ? data.option : null,
      };

      if (data.rdv1 != null) draft.rdv1 = data.rdv1;
      if (data.rdv2 != null) draft.rdv2 = data.rdv2;
      if (data.rdv3 != null) draft.rdv3 = data.rdv3;
      if (data.acceptRdv != null) draft.acceptRdv = data.acceptRdv;

      if (data.avis === "accepté") {
        draft.motifRefus = [];
        draft.motifRefusTxt = null;
      } else if (data.avis === "refusé") {
        draft.motifRefus = data.motifRefus != null ? data.motifRefus : [];
        draft.motifRefusTxt =
          data.motifRefusTxt != null ? data.motifRefusTxt : null;
      }

      return draft;
    },
    resolveRefusalStateId() {
      const currentStateId =
        this.request.state && this.request.state.id != null
          ? this.request.state.id
          : this.request.stateId;

      if (currentStateId === 13 || currentStateId === 12) {
        return 13;
      }
      return 12;
    },
    async sendPhotoWithRetry(file, photoNumber, maxRetries = 2) {
      file.requestId = this.request.id;
      file.stdUserId = this.userConnected.id;
      file.typeDocumentId = 104;

      let lastError;
      for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
          await this.sendDocument({ file, skipGlobalSpinner: true });
          return;
        } catch (error) {
          lastError = error;
          if (attempt < maxRetries) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }
      }

      const detail =
        lastError && lastError.message ? lastError.message : "échec de l'envoi";
      throw new Error(`Photo ${photoNumber} : ${detail}`);
    },
    async ensureReceptionExists(data, skipGlobalSpinner = false) {
      const exists = await this.getReception(
        skipGlobalSpinner
          ? { id: this.request.id, skipGlobalSpinner: true }
          : this.request.id
      );
      if (exists) {
        return;
      }

      // Ne pas envoyer de stateId : la création d'une réception brouillon
      // ne doit pas réécrire le statut du dossier.
      await this.updateReception({
        ...data,
        requestId: this.request.id,
        noMail: true,
        ...(skipGlobalSpinner ? { skipGlobalSpinner: true } : {}),
      });
    },
    async persistReception(data, skipGlobalSpinner = false) {
      const payload = skipGlobalSpinner ? { ...data, skipGlobalSpinner: true } : data;
      // POST /reception exige une transition d'état (6/7) ; un brouillon sans stateId
      // doit toujours passer par PUT pour ne pas écraser le statut.
      if (this.request.state.id == 4 && payload.stateId != null) {
        await this.addReception(payload);
      } else {
        await this.updateReception(payload);
      }
    },
    async newReception(data, roadDisturbance, updateDossier) {
      data.id = this.request.id;
      data.requestId = this.request.id;
      data.roadDisturbance = roadDisturbance;

      const shouldValidate = updateDossier === true;
      if (shouldValidate) {
        this.isValidating = true;
        this.validationStep = "";
      }

      try {
        if (!shouldValidate) {
          const draft = this.buildReceptionDraftPayload(data);
          await this.ensureReceptionExists(draft);
          await this.persistReception({ ...draft, noMail: true });
          Vue.prototype.$awn.info("Brouillon de réception sauvegardé.");
          this.vModel = false;
          return;
        }

        this.validationStep = "Préparation de la réception…";
        await this.ensureReceptionExists(
          this.buildReceptionDraftPayload(data),
          true
        );

        if (this.receptionSelected.avis === "refusé") {
          data.stateId = this.resolveRefusalStateId();
          data.applyState = true;

          const photosToUpload = this.photoReceptionRefus.filter(
            (photoObj) => photoObj.file != null
          );
          let uploadedCount = 0;
          for (const photoObj of this.photoReceptionRefus) {
            if (photoObj.file == null) {
              continue;
            }
            uploadedCount += 1;
            this.validationStep = `Envoi photo ${uploadedCount}/${photosToUpload.length}…`;
            await this.sendPhotoWithRetry(photoObj.file, uploadedCount);
          }

          if (this.request.documents) {
            for (const document of this.request.documents) {
              if (
                document.typeDocument.id == 106 &&
                document.name === "mise-en-demeure-" + this.request.id + ".docx"
              ) {
                this.validationStep = "Envoi de la mise en demeure…";
                await this.sendDocumentElise(document.id);
              }
            }
          }

          this.validationStep = "Conversion du PV en PDF…";
          await this.updateDossier({
            ...this.buildDossierPayload(data),
            skipGlobalSpinner: true,
          });

          this.validationStep = "Finalisation de la réception…";
          await this.persistReception(data, true);

          Vue.prototype.$awn.info("Réception refusée.");
        } else if (this.receptionSelected.avis === "accepté") {
          data.stateId = 2;
          data.applyState = true;
          data.motifRefus = [];
          data.motifRefusTxt = null;

          this.validationStep = "Conversion du PV en PDF…";
          await this.updateDossier({
            ...this.buildDossierPayload(data, { sendToSign: true }),
            skipGlobalSpinner: true,
          });

          this.validationStep = "Finalisation de la réception…";
          await this.persistReception(data, true);

          Vue.prototype.$awn.info("Dossier réceptionné.");
        } else {
          await this.persistReception(
            this.buildReceptionDraftPayload(data),
            true
          );
        }

        await this.getDossier({ id: this.request.id, skipGlobalSpinner: true });
        this.vModel = false;
      } catch (error) {
        const message =
          (error && error.message) ||
          "Erreur lors de la validation de la réception.";
        Vue.prototype.$awn.alert(message, {
          position: "bottom-right",
          timeout: 8000,
        });
      } finally {
        if (shouldValidate) {
          this.isValidating = false;
          this.validationStep = "";
        }
      }
    },
    addRoadDisturbance(data) {
      data.id = this.request.id;
      data.stateId = 2;
      data.applyState = true;
      data.roadDisturbance = true;

      const photo = this.photo;
      if (photo.file != null) {
        photo.file.requestId = this.request.id;
        photo.file.stdUserId = this.userConnected.id;
        photo.file.typeDocumentId = 111;
        this.sendDocument(photo.file);
      }

      this.updateReception(data);

      data.addressCity = this.request.addressCity;
      data.lat = this.request.lat;
      data.lon = this.request.lon;
      data.madeDate = this.request.madeDate;
      this.updateDossier(data);
      this.roadDisturbance = false;
    },
    async doCourrier(receptionSelected, mode) {
      // console.log(receptionSelected);
      let dataToSend = {};
      this.request.tokenUser = window.$cookies.get("token-sudthd");
      this.request.dateNow = moment().format("DD/MM/YYYY");
      let idModele = -1;
      switch (mode) {
        case "pv":
          if (this.request["cerfa1402301"] != null) {
            if (this.request["cerfa1402301"]["isAccessDevelopment"]) {
              idModele = 7; // PV-acces
            } else {
              if (receptionSelected.option == "Photos" || this.request.state.id == 4) {
                idModele = 8; // PV-Photos
              } else {
                idModele = 9; // PV-Rendez-vous
              }
            }
          }
          break;

        case "md":
          idModele = 6;
          break;

        case "dv":
          idModele = 10; // PV de désordre de voirie
          break;
      }
      Object.flatten = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            for (var i = 0, l = cur.length; i < l; i++)
              recurse(cur[i], prop + "[" + i + "]");
            if (l == 0) result[prop] = null;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      dataToSend = Object.flatten(this.request);

      let instructeurId = this.request.instructeurId;
      if (this.request.instructeurId !== this.userConnected.id) {
        instructeurId = this.userConnected.id;
      }
      dataToSend.instructeurId = instructeurId;

      dataToSend.receptionIns_dateVisite = this.formatDate(receptionSelected.dateVisite);
      dataToSend.receptionIns_avis = receptionSelected.avis;

      if (receptionSelected.motifRefus) {
          let motifRefus = [];

          receptionSelected.motifRefus.forEach((motif) => {
          
            switch (motif.toLowerCase()) {
              case "joints":
                motifRefus.push("- La tranchée n'est pas étanchée par un joint en émulsion de bitume");
                break;
              case "redans":
                motifRefus.push("- La découpe n'est pas rectiligne");
                break;
              case "prescriptions non respectées":
                motifRefus.push("- La réfection n'est pas conforme aux prescriptions de la permission de voirie");
                break;
              case "autre":
                motifRefus.push("- " + receptionSelected.motifRefusTxt);
                break;
            }
        });

        dataToSend.receptionIns_motifRefus = motifRefus.join("<br>");
      }
      

      dataToSend.reception_option = receptionSelected.option;
      dataToSend.roadDisturbance = false;
      if (mode == "dv") {
        dataToSend.roadDisturbance = true;

        if (this.instructeurSelected != null) {
          dataToSend.instructeur = this.instructeurSelected;
        }

        dataToSend.comment = this.comment;

        let datePvReception = this.getTodayDate();
        let pvReception = this.request.documents.filter(document => document.typeDocument.id == 108);
        let pvReceptionSigne = this.request.documents
          .filter(document => document.typeDocument.id == 109)
          .sort((a, b) => {
            // Prefer -v2 (latest acceptance) over the first version
            const aIsV2 = a.name && a.name.includes("-v2");
            const bIsV2 = b.name && b.name.includes("-v2");
            if (aIsV2 !== bIsV2) {
              return aIsV2 ? -1 : 1;
            }
            return b.id - a.id;
          });
        if (pvReception.length != 0) {
          datePvReception = pvReception[0].createdAt.split(" ")[0];
        } else if (pvReception.length == 0 && pvReceptionSigne.length != 0) {
          datePvReception = pvReceptionSigne[0].createdAt.split(" ")[0];
        }
        dataToSend.datePvReception = datePvReception;
      } else {
        dataToSend.roadDisturbance = false;
      }
      dataToSend.courrier_idModele = idModele;
      await this.startMerge(dataToSend);
      this.showBtnGenProcesVerbalDesordreVoirie = false;
      //Permet de récupérer les documents juste après l'avoir générer
      await this.getDossier(this.request.id);
      return;
    },

    editCourrier(typeCou) {
      let docMiseEnDemeureid = null;
      if (this.request.documents && typeCou == "md") {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 106) {
            docMiseEnDemeureid = element.id;
          }
        });
      }
      if (this.request.documents && (typeCou == "pv")) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 108) {
            docMiseEnDemeureid = element.id;
          }
        });
      }
      if (docMiseEnDemeureid !== null) {
        let url = window.urlapi + 'onlyoffice/' + docMiseEnDemeureid;

        fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
      } else {
        alert("Aucun arrêté de généré pour cette demande");
      }
    },
    editCourrierDv(idCourrier) {
      if (idCourrier !== null) {
        let url = window.urlapi + 'onlyoffice/' + idCourrier;

        fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
      } else {
        alert("Aucun PV généré pour cette demande");
      }
    },
    async removeCourrier(typeCou) {
      let doc = false;
      if (this.request.documents && typeCou == "md") {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 106) {
            doc = element;
          }
        });
      }
      if (this.request.documents && typeCou == "pv") {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 108) {
            doc = element;
          }
        });
      }
      await this.removeDocument(doc.id);
      await this.getDossier(this.request.id);
      return;
    },
    async removeCourrierDv(idCourrier) {
      await this.removeDocument(idCourrier);
      await this.getDossier(this.request.id);
      return;
    },
    validReception() {
      this.vModel = false;
    },
    formatDate(date) {
      let parts = date.split('-');

      let y = parts[0];
      let m = parts[1];
      let d = parts[2];

      return d + '/' + m + '/' + y;
    },
    pvReceptionExiste() {
      const idTypeDocPvReception = [106, 107, 108, 109];
      let pvReception = this.request.documents.filter(doc => idTypeDocPvReception.includes(doc.typeDocument.id));
      return pvReception.length != 0;
    },
    getPvDesordreVoirie() {
      this.pvDesordreVoirie = this.request.documents.filter(doc => doc.typeDocument.id == 110);
    },
    getTodayDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    },
    ...Vuex.mapActions("GED", ["sendDocumentElise"]),
    ...Vuex.mapActions("Cerfa", ["setCerfa14023", "updateCerfa14023"]),
    ...Vuex.mapActions("Document", ["sendDocument", "removeDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "setReception",
      "addReception",
      "sendToClicmap",
    ]),
  },
  watch: {
    'request.documents': {
      handler() {
        this.getPvDesordreVoirie();
      },
    },
  },
  mounted() {
    if (this.request.documents && this.request.documents.length > 0) {
      this.getPvDesordreVoirie();
    }
  },
  computed: {
    receptionSelected: {
      get: function() {
        return this.reception;
      },
      set: function(newValue) {
        this.setReception(newValue);
      },
    },
    showBtnValider() {
      return !this.pvReceptionExiste();
    },
    //Mise en demeure
    showBtnGenMiseEnDemeure() {
      return (
        this.receptionSelected.avis == null || this.receptionSelected.avis == ""
      );
    },
    showBtnEditMiseEnDemeure() {
      let disabled = true;
      if (this.request.documents && this.receptionSelected.avis == "refusé") {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 106) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    // Proces verbal
    showBtnGenProcesVerbal() {
      return (
        this.receptionSelected.avis == null || this.receptionSelected.avis == ""
      );
    },
    showBtnEditProcesVerbal() {
      let disabled = true;
      // console.log("showBtnEditProcesVerbal");
      // console.log(this.request.documents);
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 108) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },

    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>

<style>
.pv-dv-header {
  font-weight: bold;
  background-color: #7a7a7a;
  color: white;
}
</style>
